import { useQuery } from '@tanstack/react-query';
import { getCustomers, getCustomer } from '@/services/customers.api';

export function useCustomers(siteId: string | null, filters: { page?: number; perPage?: number; search?: string }) {
  return useQuery({
    queryKey: ['customers', siteId, filters],
    queryFn: () => getCustomers(siteId!, filters),
    enabled: !!siteId,
  });
}

export function useCustomerDetail(siteId: string | null, customerId: number) {
  return useQuery({
    queryKey: ['customer', siteId, customerId],
    queryFn: () => getCustomer(siteId!, customerId),
    enabled: !!siteId && !!customerId,
  });
}
